export default __webpack_public_path__ + "static/media/j5.d949f0a7.jpeg";